// extracted by mini-css-extract-plugin
export var errorIcon = "_oe-1";
export var nameLogo = "_oe-0";